/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventfieldticketlink3Inputs */

const en_eventfieldticketlink3 = /** @type {(inputs: Eventfieldticketlink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket link`)
};

const de_eventfieldticketlink3 = /** @type {(inputs: Eventfieldticketlink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketlink`)
};

/**
* | output |
* | --- |
* | "Ticket link" |
*
* @param {Eventfieldticketlink3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventfieldticketlink3 = /** @type {((inputs?: Eventfieldticketlink3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventfieldticketlink3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventfieldticketlink3(inputs)
	return de_eventfieldticketlink3(inputs)
});
export { eventfieldticketlink3 as "eventFieldTicketLink" }